import { GenericModel } from "../../../generic.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { CurrencyModel } from "../../common/currency.model";

export class GenericTotalModel extends GenericModel {
    public currencyArray: CurrencyModel[];
    public xApply: string;
    public xRank: string;
    public xReason!: string;
    public xSellLocation: string;
    public xUnit: string;

    protected fromJson(json?: any): boolean {
        this.currencyArray = makeModel(json.currencyArray, CurrencyModel);
        this.xApply = json.xApply ?? null;
        this.xRank = json.xRank ?? null;
        this.xReason = json.xReason ?? null;
        this.xSellLocation = json.xSellLocation ?? null;
        this.xUnit = json.xUnit ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return true;
    }
}